import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './entity-attribute.reducer';

export const EntityAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const entityAttributeEntity = useAppSelector(state => state.entityAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="entityAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.entityAttribute.detail.title">EntityAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.id}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.entityId}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.name">Name</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.name}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.value}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.timestampEntry}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.entityAttribute.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{entityAttributeEntity.sortOrder}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.entityAttribute.parent">Parent</Translate>
          </dt>
          <dd>{entityAttributeEntity.parent ? entityAttributeEntity.parent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/entity-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/entity-attribute/${entityAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EntityAttributeDetail;
